import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './resource-location.css';
import { APP_TEXT } from '../../const/app-text';

// ------------------------------------------------------------

const text = APP_TEXT.components.resourceLocationModal;

export interface ResourceLocationModalProps {
  isOpen: boolean;
  onSave?: () => void;
  onClose: () => void;
}

const ResourceLocationModal = ({ isOpen, onClose }: ResourceLocationModalProps) => {
  useEffect(() => {
    if (isOpen === true) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    } else {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = '';
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="resourceLocationModal"
    >
      <div
        className="resourceLocationModalWrapper"
        aria-modal
        role="alertdialog"
        aria-label="Resource Location Modal"
      >
        <div className="resourceLocationModalContent">
          <Typography
            variant="h2"
            fontWeight={700}
          >
            {text.title}
          </Typography>

          <div className="contentBody">
            <Typography
              variant="body"
              fontWeight={700}
            >
              {text.externalResources.title}
            </Typography>
            <Typography variant="body">{text.externalResources.body.partOne}</Typography>
            <Typography variant="body">{text.externalResources.body.partTwo}</Typography>
          </div>

          <div className="contentBody">
            <Typography
              variant="body"
              fontWeight={700}
            >
              {text.internalResources.title}
            </Typography>
            <Typography variant="body">{text.internalResources.body}</Typography>
          </div>
        </div>

        <div className="resourceLocationModalButton">
          <PrimaryButton
            variant={ButtonVariant.Solid}
            size={ButtonSize.Large}
            onClick={onClose}
          >
            {text.close}
          </PrimaryButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ResourceLocationModal;
